/**
 * Veeam Service Provider Console REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Indicates whether Veeam Backup & Replication must process application logs or create copy-only backups.
 */
export enum BackupServerTransactionLogsSettings {
    Process = 'process',
    CopyOnly = 'copyOnly'
};

